import styled from '@mui/system/styled';
import Box from '@mui/material/Box';

export const CardMediaContainer = styled(Box)(() => ({
  backgroundColor: '#c9cdcf',
  height: '200px',
  position: 'relative',
  marginBottom:'0rem',
}));

export default CardMediaContainer;
